import { render, staticRenderFns } from "./LawCourtForm.vue?vue&type=template&id=3f6bf4bc&"
import script from "./LawCourtForm.vue?vue&type=script&lang=js&"
export * from "./LawCourtForm.vue?vue&type=script&lang=js&"
import style0 from "./LawCourtForm.vue?vue&type=style&index=0&id=3f6bf4bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports